import { createQueryKeys } from "@lukemorales/query-key-factory";
import { PuObrazacListPayload } from "./poreskaUprava.types";

/**
 * Keys used to invalidate stored cached data regarding poreska uprava module
 */
export const puObrasciKeys = createQueryKeys("pu_obrasci", {
  puObrasciList: ({ filters }: { filters: Partial<PuObrazacListPayload> }) => ({
    queryKey: ["pu_obrasci_list", filters],
  }),
});
